import { memo, useCallback } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  ScrollArea,
} from '@flote/ui';
import { DestinationForm, type DestinationFormData } from './DestinationForm';

interface DestinationFormModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: DestinationFormData) => Promise<void>;
  isProcessing?: boolean;
}

export const DestinationFormModal = memo<DestinationFormModalProps>(({
  open,
  onOpenChange,
  onSubmit,
  isProcessing = false,
}) => {
  const handleOpenChange = useCallback(
    (newOpen: boolean) => {
      if (!newOpen && !isProcessing) {
        onOpenChange(false);
      }
    },
    [onOpenChange, isProcessing]
  );

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-2xl max-h-[90vh] p-0 sm:w-full">
        <DialogHeader className="px-6 pt-6 pb-4">
          <DialogTitle>Create Destination</DialogTitle>
          <DialogDescription>
            Create a new destination with address details for delivery tasks
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="max-h-[calc(90vh-120px)]">
          <div className="px-6 pb-6">
            <DestinationForm
              onSubmit={onSubmit}
              isProcessing={isProcessing}
            />
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
});

DestinationFormModal.displayName = 'DestinationFormModal';
